class PickFile {

    constructor() {

        this.element = '.pick-file';

        this.bindClick();
        this.bindChange();
    }

    bindClick() {
        
        $(document).ready(() => {

            $(this.element).on('click', (event) => {
                $(event.currentTarget).parent().find('input[type="file"]').click();
            });

        })

    }

    bindChange() {

        $(document).ready(() => {

            $(this.element).parent().find('input[type="file"]').on('change', (event) => {
                $(event.currentTarget).parent().find('input[type="text"]').val($(event.currentTarget).val());
            });
        });

    }

}

export const pickFile = new PickFile();